import { AxiosRequest } from "../../../Url";
import { defaultFieldInfo, getRightsData, getStyleWindow, setColor } from "../../Tools/Tools";
import { CreateCollapsibleRecords } from "../GridTools/collapsibleRecordsTools";
import { getParamColumnsOptions, parseColumns, ParsedColumn } from "../GridTools/parseColumnTools";
import { createGrid, createRecordSource } from "../rcsgrid";
import smetaAxios from "../../../SmetaAxios";
import { DelphiColors, EditStyle, ParamSetOption, Prefixes } from "../../Tools/ProjectX";
import { HTMLGridTableCellElement, HTMLGridTableElement } from "../../../ComponentInterface";
import { configEnabledAtom, smetaStore } from "../../../../atoms";
import { ObjType } from "../../Tools/Consts";
import { smetaModals } from "../../Tools/modalManager";
import DialogHistory from "../../Module/Dialogs/DialogHistory";

const changeGridStyles = async (table: HTMLGridTableElement, grid: createGrid) => {
  const recordInfo = grid.source.getRecordInfo();
  if (recordInfo?.outOfDate && table.classList[0] === "grid-item") table.style.textDecoration = "line-through";
  for (const cell of Array.from(table.querySelectorAll<HTMLGridTableCellElement>(".grid-td"))) {
    const { fieldName } = cell.field;
    if (fieldName === "Params") {
      const fieldText = await grid.source.getFieldText(fieldName);
      const fieldValue = await grid.source.getFieldValue(fieldName);
      const hasTextAndIsEmpty = fieldText && fieldValue === undefined;
      if (hasTextAndIsEmpty) cell.style.color = setColor(DelphiColors.clGray);
    }
  }
};

export async function accountsPlanGrid(grid: createGrid, source: createRecordSource, props, data) {
  const editColumnHistory = async () => {
    const objRef = source.getFieldTextSync("ID");
    const paramsRequest = new Map();
    paramsRequest
      .set("prefix", Prefixes.acc)
      .set("ObjType", ObjType.AccountPlan)
      .set("ShortName", "ПараметрыСчета")
      .set("ID", objRef);
    smetaModals.open(
      <DialogHistory
        EditStyle={EditStyle.PickList + EditStyle.CheckList}
        paramsRequest={paramsRequest}
        noEdit={!data.canChangeAccountParamsRef.current}
        onSelect={() => {
          grid.refreshSource("!");
        }}
      />,
      {
        Title: "Параметры счета",
        style: getStyleWindow(),
        blockMaximize: true,
        blockSaveLocation: true,
      },
    );
  };
  grid.changeGridStyles = changeGridStyles;
  source.onHandleRequest = handleAccountsPlanRequest(props);
  source.CreateCollapsibleRecords = CreateCollapsibleRecords;
  const columns = {
    title: [
      {
        fieldName: "Code",
        title: "Код счета",
        width: 120,
        level: 0,
        collapseRecord: true,
        fieldInfo: { ...defaultFieldInfo, options: getParamColumnsOptions(ParamSetOption.Fixed) },
      },
      { fieldName: "Name", title: "Наименование счета", width: 320, level: 0, fieldInfo: { ...defaultFieldInfo } },
      {
        fieldName: "Params",
        title: "Параметры счета",
        width: 120,
        level: 0,
        fieldInfo: {
          ...defaultFieldInfo,
          onEditButtonClick: editColumnHistory,
          EditStyle: data.checkParamsHistoryRef.current
            ? EditStyle.Ellipsis + EditStyle.ReadOnly
            : EditStyle.PickList + EditStyle.Ellipsis + EditStyle.CheckList,
        },
      },
      {
        fieldName: "Alias",
        title: "Замена кода",
        width: 170,
        level: 0,
        hide: true,
        fieldInfo: { ...defaultFieldInfo },
      },
    ],
  };
  source.rights = getRightsData("-1");
  grid.canModify = (flag: number, column: ParsedColumn | undefined) => {
    if (!grid.localCanModify(flag, column, grid)) return false;
    if (!data.checkParamsHistoryRef.current || column?.fieldName !== "Params") return smetaStore.get(configEnabledAtom);
    return true;
  };
  if (data.tableLayout) {
    grid.setColumns(parseColumns(data.tableLayout, { inputColumns: columns }));
  } else grid.setColumns(columns);

  await source.open();

  await grid.setSource(source);

  source.onRecordCollapsed = async (event) => {
    const recordIndex = event.currentTarget !== undefined ? event.currentTarget.getAttribute("recordindex") : event;
    await smetaAxios.get("RecordCollapsed", {
      prefix: props.Module,
      params: { SectionID: props.SectionID, ObjType: data.accPlanNoRef.current, RecordIndex: recordIndex },
      loadMask: true,
    });
    await grid.refreshSource("!");
    if (data.setCountRecords) data.setCountRecords(source.recordCount);
    return;
  };

  await grid.refreshSource();

  if (data.setSelectedRecord) {
    source.onRecordIndexChanged = async (source) => {
      data.setSelectedRecord(source.getFieldTextSync("ID"));
    };
    data.setSelectedRecord(source.getFieldTextSync("ID"));
  }
  if (data.onMultiSelectChange) {
    grid.onMultiSelectChange = () => {
      data.onMultiSelectChange();
    };
  }

  await grid.updateGridSize();
}

export const handleAccountsPlanRequest = (props: { SectionID?: string | number; ObjType: string }) => {
  return (request, loadCursor) => {
    const params = new Map();
    params
      .set("prefix", Prefixes.acc)
      .set("comand", "HandlePlanTable")
      .set("ObjType", props.ObjType)
      .set("SectionID", props.SectionID);
    return AxiosRequest(loadCursor !== undefined ? loadCursor : true, params, request);
  };
};
